<template>
  <div class="part-inventory-dialog">
    <custom-dialog
      width="1100px"
      :title="model.title"
      :visible="visible"
      v-on="$listeners"
    >
      <div class="dialog-body">
        <el-form
          :model="form"
          ref="form"
          :inline="true"
          label-position="top"
          :rules="rules"
        >
          <el-form-item
            :label="$t('dms_part_inventory_dialog.ru_ku_dan_hao')"
            prop="inBatchNum"
          >
            <el-input
              v-model="form.inBatchNum"
              style="width: 180px"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('dms_part_inventory_dialog.ru_ku_ren')"
            prop="inUser"
          >
            <el-input
              v-model="form.inUser"
              style="width: 180px"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('dms_part_inventory_dialog.ru_ku_shi_jian')"
            prop="inTime"
          >
            <custom-date-picker
              style="width: 180px"
              v-model="form.inTime"
              type="date"
              value-format="YYYY-MM-DD HH:mm:ss"
              :picker-options="beforeToday"
            ></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('dms_part_inventory_dialog.cai_gou_dan_hao')">
            <el-input v-model="form.poNum"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_part_inventory_dialog.lai_liao_dan_hao')">
            <el-input v-model="form.incomingNum"></el-input>
          </el-form-item>
        </el-form>
        <!-- 入库信息 -->
        <div class="handle-role">
          <div class="role-list">
            <ul>
              <li>
                <div class="item-head ub">
                  <el-row
                    :gutter="10"
                    class="ub-f1"
                  >
                    <el-col :span="1">
                      <h1>#</h1>
                    </el-col>
                    <el-col :span="4">
                      <h1>{{ $t('dms_part_inventory_dialog.ling_jian_lei_bie') }}</h1>
                    </el-col>
                    <el-col :span="4">
                      <h1>{{ $t('dms_part_inventory_dialog.ling_jian_lei_xing') }}</h1>
                    </el-col>
                    <el-col :span="4">
                      <h1>{{ $t('dms_part_inventory_dialog.ling_jian_bian_hao') }}</h1>
                    </el-col>
                    <el-col :span="4">
                      <h1>{{ $t('dms_part_inventory_dialog.ling_jian_ming_cheng') }}</h1>
                    </el-col>
                    <el-col :span="4">
                      <h1>{{ $t('dms_part_inventory_dialog.ling_jianSN') }}</h1>
                    </el-col>
                    <el-col :span="3">
                      <h1>{{ $t('dms_part_inventory_dialog.zhi_bao_shi_jian') }}</h1>
                    </el-col>
                  </el-row>
                  <div class="icon-box"></div>
                </div>
                <div class="children">
                  <div
                    class="item ub"
                    v-for="(item, index) in partList"
                    :key="index"
                  >
                    <el-row
                      :gutter="10"
                      class="ub-f1"
                    >
                      <el-col :span="1">
                        <div class="num">
                          {{ index + 1 }}
                        </div>
                      </el-col>
                      <!-- 零件类别 -->
                      <el-col :span="4">
                        <custom-select
                          v-model="item.partClass"
                          code="asm_part_class"
                          @change="partClassChange(index)"
                        ></custom-select>
                      </el-col>
                      <!-- 零件类型 -->
                      <el-col :span="4">
                        <custom-select
                          v-model="item.partType"
                          code="asm_part_type"
                          @change="partTypeChange(index)"
                        ></custom-select>
                      </el-col>
                      <!-- 零件编号 -->
                      <el-col :span="3">
                        <part-list-select
                          :dataFilter="partCodeFilter"
                          :filterOptions="{ partClass: item.partClass, partType: item.partType }"
                          v-model="item.partCode"
                          :placeholder="index !== 0 ? $t('dms_part_inventory_dialog.mo_ren_tong_shang') : $t('Common.com_required')"
                          :props="{ label: 'partCode', value: 'partCode' }"
                          width="100%"
                          @change="changePartName(arguments[0], item)"
                        ></part-list-select>
                      </el-col>
                      <!-- 零件名称 -->
                      <el-col :span="4">
                        <el-input
                          :placeholder="index !== 0 ? $t('dms_part_inventory_dialog.mo_ren_tong_shang') : ''"
                          v-model="item.partName"
                          style="width: 100%"
                          :disabled="true"
                        ></el-input>
                      </el-col>
                      <!-- 零件SN -->
                      <el-col :span="4">
                        <el-input
                          v-model="item.partSn"
                          style="width: 100%"
                          :placeholder="showSnPlaceholder(item, index) ? $t('Common.com_required') : ''"
                        ></el-input>
                      </el-col>
                      <!-- 质保时间 -->
                      <el-col :span="4">
                        <custom-date-picker
                          style="width: 100%"
                          v-model="item.warrantyDate"
                          type="date"
                          :picker-options="afterToday"
                        ></custom-date-picker>
                      </el-col>
                    </el-row>
                    <div
                      class="icon-box"
                      @click="deleteModel(index)"
                    >
                      <i
                        v-if="index !== 0"
                        class="icon icon-shanchu"
                      ></i>
                    </div>
                  </div>
                  <div
                    class="add-child-btn"
                    @click="addModel"
                  >
                    <div style="display: inline-block">
                      <i class="icon icon-add"></i>
                      <span>{{ $t('dms_part_inventory_dialog.tian_jia_ling_jian') }}</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button
          type="primary"
          @click="saveConfirm"
        >{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
// import moment from 'moment';
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import mixins from './mixins.js';
import partListSelect from './part_list_select';

export default {
  mixins: [dialogMixins, mixins],
  components: {
    partListSelect
  },
  data() {
    return {
      visible: false,
      orgOptions: [],
      loading1: false,
      productOptions: [],
      radio: false,
      form: {
        inBatchNum: '',
        inUser: '',
        inTime: '',
      },

      formItem: {
        partCode: '',
        partSn: '',
        partName: '',
        bodyNum: '',
        productCode: '',
        componentCode: '',
        // 采购单号
        poNum: '',
        // 来料单号
        incomingNum: '',
      },
      partList: [],
    };
  },
  mounted() {
    this.init();
  },

  computed: {
    rules() {
      return {
        inTime: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        // shipmentNum: { required: true, message: '请填写入库单号' }
      };
    },
  },
  methods: {
    showSnPlaceholder(row, index) {
      if (index === 0) {
        return true;
      }
      return row.partClass || row.partType || row.partCode || row.partName || row.warrantyDate;
    },
    partCodeFilter(selData, filterOption) {
      if (!filterOption.partClass || !filterOption.partType) {
        return [];
      }
      let ret = selData;
      if (filterOption.partClass) {
        ret = ret.filter(item => `${item.partClass}` === `${filterOption.partClass}`);
      }

      if (filterOption.partType) {
        ret = ret.filter(item => `${item.partType}` === `${filterOption.partType}`);
      }

      return ret;
    },
    partClassChange(index) {
      this.partList[index].partCode = '';
      this.partList[index].partName = '';
    },
    partTypeChange(index) {
      this.partList[index].partCode = '';
      this.partList[index].partName = '';
    },
    // 初始化
    init: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      const models = [];
      models.push(JSON.parse(JSON.stringify(this.formItem)));
      models.push(JSON.parse(JSON.stringify(this.formItem)));
      models.push(JSON.parse(JSON.stringify(this.formItem)));
      models.push(JSON.parse(JSON.stringify(this.formItem)));
      models.push(JSON.parse(JSON.stringify(this.formItem)));
      this.partList = models;
      this.form.inTime = this.$momentElLocal(new Date());
      // this.remoteMethod();
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    changePartCode: function (item) {
      item.partCode = '';
      item.partName = '';
    },
    changePartName: function (partCodeItem, item) {
      if (partCodeItem) {
        item.partName = partCodeItem.partName;
      } else {
        item.partName = '';
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },

    // 新增设备
    addModel: function () {
      this.partList.push(JSON.parse(JSON.stringify(this.formItem)));
    },
    // 删除设备
    deleteModel: function (index) {
      this.partList.splice(index, 1);
    },
    // 保存入库设备
    saveConfirm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 过滤全空的列
          const arr = this.partList.filter(t => t.partClass || t.partType || t.partCode || t.partSn || t.partName || t.bodyNum || t.productCode || t.componentCode);
          if (arr.length === 0) {
            this.$message.error(this.$t('dms_part_inventory_dialog.qtjlj'));
            return;
          }
          const list = this.$formatCopyUp(arr, ['partCode', 'partName', 'partClass', 'partType']);
          const hasEmpty = list.find(t => !t.partCode || !t.partSn);
          if (hasEmpty) {
            this.$message.error(this.$t('dms_part_inventory_dialog.qjljtxwz'));
            return;
          }
          const reqData = {
            ...this.form,
            detailList: list,
          };
          this.saveInStock(reqData);
        }
      });
    },
    // 保存
    saveInStock: function (reqData) {
      this.$postJSON(apis.partStockAdd, reqData).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
  },
};
</script>

<style lang="scss">
.part-inventory-dialog {
  .title {
    font-size: 16px;
    line-height: 24px;
    position: relative;
    padding-left: 12px;
    margin-bottom: 20px;
    color: #262626;
  }
  .title .bar {
    left: 0;
    width: 4px;
    height: 15px;
    background-color: #00afff;
  }
  .role-list {
    ul li {
      margin-top: 10px;
      border: 1px solid rgba(228, 228, 228, 1);
      &:first-child {
        margin-top: 0;
      }
    }
    .item-head {
      background: rgba(245, 245, 245, 1);
      border-bottom: 1px solid rgba(228, 228, 228, 1);
      padding: 0 10px;
      h1 {
        line-height: 40px;
        font-size: 12px;
        color: #262626;
        font-weight: bold;
        text-indent: 6px;
      }
      .icon-box {
        width: 30px;
        margin-left: 10px;
      }
    }
    .children {
      padding: 15px 0;
      .item {
        padding: 5px 10px 0;
        &:first-child {
          padding-top: 0;
        }
        .icon-box {
          line-height: 30px;
          width: 30px;
          margin-left: 10px;
          text-align: center;
          .icon {
            color: #00afff;
            font-size: 14px;
            cursor: pointer;
          }
        }
      }
      .el-input-group__append {
        border-radius: 0;
        .copy-up {
          padding: 0 8px;
          .el-radio__label {
            padding-left: 5px;
          }
        }
      }
      .num {
        width: 100%;
        line-height: 32px;
        height: 100%;
        font-size: 12px;
        text-indent: 6px;
      }
    }
  }
  .other-role {
    margin-top: 30px;
  }

  .add-child-btn {
    background: rgba(245, 245, 245, 1);
    border: 1px dashed rgba(228, 228, 228, 1);
    line-height: 30px;
    text-align: center;
    color: #333333;
    font-size: 12px;
    margin: 14px 10px 0;
    cursor: pointer;
    .icon {
      color: #00afff;
      font-size: 10px;
      margin-right: 8px;
      float: left;
    }
  }
}
</style>
